module.exports = __webpack_public_path__ + "img/new-guide-02-1.280f033f.png";